// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sharedColorPalette_bN6hZ {
  width: 100%;
}

.paletteGrid_eQEMa {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

.grid_KaQE3 .paletteGrid_eQEMa {
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex-wrap: wrap;
}

.list_TyXN5 .paletteGrid_eQEMa {
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.paletteItem_jeLla {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  text-align: center;
  background-color: var(--white-background, #ffffff);
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 200px;
}

.paletteItem_jeLla:hover {
  border-color: #b6b6b6;
}

.paletteItem_jeLla.selected_j4uXp {
  border-color: #b6b6b6;
  background-color: #f5f5f5;
}

.grid_KaQE3 .paletteItem_jeLla {
  min-height: 100px;
  max-width: 200px;
}

.list_TyXN5 .paletteItem_jeLla {
  flex-direction: row;
  min-height: 50px;
  max-width: 100%;
  padding: 8px 12px;
  align-items: center;
  gap: 12px;
}


.previewContainer_GL87c {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin: 0 auto 8px auto;
  display: flex;
  overflow: hidden;
  border: 1px solid #eee;
  align-items: center;
  justify-content: center;
}

.list_TyXN5 .previewContainer_GL87c {
  margin: 0;
  flex-shrink: 0;
}

.colorCircle_csvcH {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 0 auto;
  border: 2px solid #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}


.colorPreview_X8Ufv {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 2px;
  overflow: hidden;
}

.primaryColor_UjdHL,
.secondaryColor_ruYJZ {
  flex: 1 1;
  height: 100%;
}

.primaryColor_UjdHL {
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

.paletteName_JA4P9 {
  font-size: 0.8rem;
  color: #555;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: auto;
}

.list_TyXN5 .paletteName_JA4P9 {
  margin-top: 0;
  flex: 1 1;
  text-align: left;
  font-size: 0.9rem;
}



@media (max-width: 768px) {
  .paletteGrid_eQEMa {
    gap: 8px;
  }
  
  .paletteItem_jeLla {
    max-width: 150px;
    min-height: 80px;
    padding: 8px;
  }
  
  .previewContainer_GL87c {
    width: 24px;
    height: 24px;
  }
  
  .colorCircle_csvcH {
    width: 20px;
    height: 20px;
  }
  
  .paletteName_JA4P9 {
    font-size: 0.7rem;
  }
}

@media (prefers-color-scheme: dark) {
  .paletteItem_jeLla {
    background-color: var(--dark-background, #2a2a2a);
    border-color: var(--dark-border, #444);
    color: var(--dark-text, #ffffff);
  }
  
  .paletteItem_jeLla:hover {
    border-color: var(--dark-border-hover, #666);
  }
  
  .paletteItem_jeLla.selected_j4uXp {
    background-color: var(--dark-selected, #3a3a3a);
    border-color: var(--dark-border-selected, #666);
  }
  
  .paletteName_JA4P9 {
    color: var(--dark-text-secondary, #cccccc);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/shared/SharedColorPalette.module.css"],"names":[],"mappings":";AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;;AAGA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,wDAAwD;EACxD,kBAAkB;EAClB,kDAAkD;EAClD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,sCAAsC;AACxC;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;;;AAIA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iDAAiD;IACjD,sCAAsC;IACtC,gCAAgC;EAClC;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,+CAA+C;IAC/C,+CAA+C;EACjD;;EAEA;IACE,0CAA0C;EAC5C;AACF","sourcesContent":["\n.sharedColorPalette {\n  width: 100%;\n}\n\n.paletteGrid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.grid .paletteGrid {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.list .paletteGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n\n.paletteItem {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  padding: 10px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  text-align: center;\n  background-color: var(--white-background, #ffffff);\n  min-height: 100px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n  max-width: 200px;\n}\n\n.paletteItem:hover {\n  border-color: #b6b6b6;\n}\n\n.paletteItem.selected {\n  border-color: #b6b6b6;\n  background-color: #f5f5f5;\n}\n\n.grid .paletteItem {\n  min-height: 100px;\n  max-width: 200px;\n}\n\n.list .paletteItem {\n  flex-direction: row;\n  min-height: 50px;\n  max-width: 100%;\n  padding: 8px 12px;\n  align-items: center;\n  gap: 12px;\n}\n\n\n.previewContainer {\n  width: 30px;\n  height: 30px;\n  border-radius: 4px;\n  margin: 0 auto 8px auto;\n  display: flex;\n  overflow: hidden;\n  border: 1px solid #eee;\n  align-items: center;\n  justify-content: center;\n}\n\n.list .previewContainer {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.colorCircle {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  margin: 0 auto;\n  border: 2px solid #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n\n\n.colorPreview {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.primaryColor,\n.secondaryColor {\n  flex: 1;\n  height: 100%;\n}\n\n.primaryColor {\n  border-right: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.paletteName {\n  font-size: 0.8rem;\n  color: #555;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-top: auto;\n}\n\n.list .paletteName {\n  margin-top: 0;\n  flex: 1;\n  text-align: left;\n  font-size: 0.9rem;\n}\n\n\n\n@media (max-width: 768px) {\n  .paletteGrid {\n    gap: 8px;\n  }\n  \n  .paletteItem {\n    max-width: 150px;\n    min-height: 80px;\n    padding: 8px;\n  }\n  \n  .previewContainer {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .colorCircle {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .paletteName {\n    font-size: 0.7rem;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .paletteItem {\n    background-color: var(--dark-background, #2a2a2a);\n    border-color: var(--dark-border, #444);\n    color: var(--dark-text, #ffffff);\n  }\n  \n  .paletteItem:hover {\n    border-color: var(--dark-border-hover, #666);\n  }\n  \n  .paletteItem.selected {\n    background-color: var(--dark-selected, #3a3a3a);\n    border-color: var(--dark-border-selected, #666);\n  }\n  \n  .paletteName {\n    color: var(--dark-text-secondary, #cccccc);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sharedColorPalette": `sharedColorPalette_bN6hZ`,
	"paletteGrid": `paletteGrid_eQEMa`,
	"grid": `grid_KaQE3`,
	"list": `list_TyXN5`,
	"paletteItem": `paletteItem_jeLla`,
	"selected": `selected_j4uXp`,
	"previewContainer": `previewContainer_GL87c`,
	"colorCircle": `colorCircle_csvcH`,
	"colorPreview": `colorPreview_X8Ufv`,
	"primaryColor": `primaryColor_UjdHL`,
	"secondaryColor": `secondaryColor_ruYJZ`,
	"paletteName": `paletteName_JA4P9`
};
export default ___CSS_LOADER_EXPORT___;
